<template>
  <div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs required">{{
          $t('setupOffer.productName')
        }}</label>
        <Select
          v-model.trim="model.product_id"
          :placeholder="$t('setupOffer.productName')"
          :filterable="true"
          :clearable="true"
          :class="{
            'ivu-form-item-error': errors.has('product_id')
          }"
        >
          <Option
            v-for="(product, index) in products"
            :key="index"
            :value="product.product_id"
            >{{ product.product_name_en }}
          </Option>
        </Select>
        <div class="validate ts-text-xs" v-if="errors.has('product_id')">
          {{ errors.first('product_id') }}
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div>
        <label class="ts-text-xs ">{{ $t('setupOffer.description') }}</label>
        <textarea
          v-model.trim="model.description"
          :placeholder="$t('setupOffer.description')"
          rows="5"
          type="text"
          class="form-control"
        ></textarea>
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh">
        <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">{{
          $t('cancel')
        }}</ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          outline
          :waiting="waiting_new"
          :disabled="waiting || waiting_new"
          @click.prevent="onSaveAddNew"
          >{{ $t('save_add_new') }}</ts-button
        >
        <ts-button
          color="primary"
          v-if="!isUpdate"
          :waiting="waiting"
          :disabled="waiting || waiting_new"
          @click.prevent="onSave"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="loading"> </Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  name: 'offer-form',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      model: {
        product_id: null,
        description: null
      }
    }
  },
  computed: {
    ...mapState('website/setupOffer', ['edit_data', 'products']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    ...mapActions('website/setupOffer', ['getProduct']),
    async fetchResource() {
      this.loading = true
      await this.getProduct()
      this.loading = false
    },

    async onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('website/setupOffer/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
          this.clearInput()
          this.waiting_new = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    async onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('website/setupOffer/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('website/setupOffer/update', {
          id: this.edit_data.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.fetchResource()
      if (!isEmpty(this.edit_data)) {
        this.model.product_id = this.edit_data.product_id
        this.model.description = this.edit_data.description
      }
    },
    clearInput() {
      this.errors = new Errors()
      this.model.product_id = null
      this.model.description = null
    }
  }
}
</script>
